import axios from 'axios'
import store from './../store'
import { setAuthenticated } from '../store/reducers/userReducer'
import { useDealershipStore } from '../store/zustand/dealershipStore'

const client = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
})

export const request = function <T>(options: Record<string, unknown>): Promise<T> {
  client.defaults.headers.common['X-Org-Id'] =
    useDealershipStore.getState()?.dealership?.organization_id ?? ''
  if (import.meta.env.DEV)
    client.defaults.headers.common['x-referer'] = window.location.href

  return client({ withCredentials: true, ...options }).then(
    (response) => response.data,
  ) as Promise<T>
}

client.interceptors.response.use(
  (res) => {
    // success
    return res
  },
  (err) => {
    const status = err?.response?.status

    if (status === 401) store.dispatch(setAuthenticated(false))

    return Promise.reject(err)
  },
)

export default request
